import {LogService} from '@aam/angular-logging';
import {BaseErrorHandlerService} from '@aam/angular-security';

export abstract class BaseAggregatorService {
  protected constructor(
    protected log: LogService,
    protected errHandler: BaseErrorHandlerService
  ) {}
}
